import React from 'react'
import borderbox1 from "../../assets/images/bordercard2.png"

const CustomersFeddback = () => {
    return (
        <>
            <section id='customerfeedback' className='mt-[-12px] xl:mt-[-90px]'>
                <div className='container' >
                    <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className=' pt-[30px] md:pt-[60px] text-nowrap text-base md:text-[30px] lg:text-[40px]  xl:text-[50px]  text-white text-center font-gothicproMedium leading-[52px]  drop-shadow-custom relative z-20 '>// COMENTARIOS DE CLIENTES</h2>
                    <div className='pt-[20px] md:pt-[60px] flex md:gap-[30px] gap-[15px] flex-wrap lg:flex-nowrap relative z-20  justify-center items-center'>
                        <div className='relative max-w-[363px] w-full overflow-hidden ' >
                            <img className='absolute top-0 left-0 right-0 bottom-0  h-[202px] w-full' src={borderbox1} alt="borderbox1" />
                            <div className='flex justify-center items-center h-[202px]' >
                                <h2 className="w-full text-wrap text-[#C9C9C9] text-center text-lg md:text-[17px] xl:text-[20px] leading-[29.4px] font-inter
                                  relative lg:pt-[23px] lg:pb-[23px] max-w-[230px] xl:max-w-[280px]
                                    after:content-['“']
                                    after:custom-glow
                                    after:text-[50px] 
                                    after:leading-[52.34px]
                                    after:font-gothicproMedium
                                    after:bg-no-repeat 
                                    after:absolute 
                                    after:top-[-10px]
                                    after:left-[-48px]
                                    after:mx-[5px]
                                    after:text-white
                                    after:w-[47px]
                                    after:rotate-x-45 
                                    after:rotate-z-45
                                    after:h-[87px]
                                    sm:after:left-[-60px]
                                    md:after:left-[-60px]
                                    md:after:top-[-15px]
                                    lg:after:top-[10px]
                                    lg:after:left-[-32px]
                                    
                                    before:content-['”']
                                    before:mx-[5px]
                                    before:bg-no-repeat
                                    before:custom-glow
                                    before:text-[50px] 
                                    before:leading-[52.34px]
                                    before:font-gothicproMedium
                                    before:absolute 
                                    before:right-[-35px]
                                    before:bottom-[-62px]
                                    before:w-[47px]
                                    before:h-[87px]
                                    before:text-white
                                    md:before:bottom-[-59px]
                                    lg:before:bottom-[-42px]
                                    lg:before:right-[-40px]
                                   ">
                                    <span className='' >
                                        Armory encontró puntos críticos de entrada para los hackers cuando otros proveedores ni siquiera
                                        se acercaron
                                    </span>
                                </h2>
                            </div>
                        </div>

                        <div className='relative max-w-[363px] w-full overflow-hidden' >
                            <img className='absolute top-0 left-0 right-0 bottom-0 w-full h-[202px] ' src={borderbox1} alt="borderbox1" />
                            <div className='flex justify-center items-center h-[202px]' >
                                <h2 className="w-full text-wrap text-[#C9C9C9] text-center text-lg md:text-[17px] xl:text-[20px] leading-[29.4px] font-inter   lg:pt-[23px]  lg:pb-[23px]  max-w-[277px] relative 
                                after:content-['“']
                                after:text-white
                                after:custom-glow
                                after:text-[50px] 
                                after:leading-[52.34px]
                                after:font-gothicproMedium
                                after:bg-no-repeat 
                                after:absolute 
                                after:top-[-16px]
                                after:left-[-25px]
                                after:md:left-[-40px] 
                                after:mx-[5px]
                                after:w-[47px]
                                after:h-[87px]
                                sm:after:top-[16px]
                                md:after:top-[10px]
                                lg:after:left-[-28px]
                                xl:after:left-[-41px]
                                
                                before:content-['”']
                                before:text-white
                                before:mx-[5px]
                                before:bg-no-repeat 
                                before:custom-glow
                                before:text-[50px] 
                                before:leading-[52.34px]
                                before:font-gothicproMedium
                                before:absolute
                                before:right-[-15px] 
                                before:bottom-[-52px]
                                before:w-[47px]
                                before:h-[87px] 
                                xl:before:bottom-[-27px]
                                md:before:bottom-[-57px]
                                xl:before:right-[-35px]
                                lg:before:bottom-[-32px]
                               ">
                                    <span>
                                        Armory ofrece insights claros, reduciendo la necesidad de monitorear manualmente y ayudándonos a estar al día con nuestras tareas
                                    </span>
                                </h2>
                            </div>
                        </div>

                        <div className='relative max-w-[363px] w-full overflow-hidden' >
                            <img className='absolute top-0 left-0 right-0 bottom-0 w-full h-[202px] ' src={borderbox1} alt="borderbox1" />
                            <div className='flex justify-center items-center h-[202px]' >
                                <h2 className="  w-full text-wrap text-[#C9C9C9]
                                 text-center text-lg md:text-[17px] xl:text-[20px] leading-[29.4px] font-inter  relative lg:pt-[23px] lg:pb-[23px] max-w-[230px] xl:max-w-[275px] 
                                after:content-['“']
                                after:text-white
                                after:custom-glow
                                after:text-[50px] 
                                after:leading-[52.34px]
                                after:font-gothicproMedium 
                                after:bg-no-repeat
                                after:absolute
                                after:top-[0px]
                                after:left-[-55px]
                                after:mx-[5px]
                                after:w-[47px]
                                after:h-[87px]
                                lg:after:left-[-42px]
                                md:after:left-[-52px]
                                
                                before:content-['”']
                                before:mx-[5px]
                                before:bg-no-repeat 
                                before:custom-glow
                                before:text-[50px] 
                                before:leading-[52.34px]
                                before:font-gothicproMedium
                                before:absolute
                                before:right-[-25px] 
                                before:bottom-[-82px]
                                before:w-[47px]
                                before:text-white
                                before:h-[87px] 
                                md:before:bottom-[-52px]
                                lg:before:bottom-[-42px]
                                lg:before:right-[-47px]
                                 ">
                                    <span className='' >
                                        El diseño de la plataforma es sencillo de navegar, analizar los hallazgos y tomar decisiones
                                    </span>
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CustomersFeddback
